import { useGlobalForm } from '@workspace/core-ts/contexts';
import { Info } from '@workspace/core-ts/icons-amo';
import { cn } from '@workspace/utils';
import { type ReactNode } from 'react';
import { RenderedContent } from '../utils';

export interface BulleAideProps {
    children?: ReactNode;
    title?: RenderedContent;
    description?: RenderedContent;
    className?: string;
    icon?: ReactNode;
    hideIcon?: boolean;
}
const iconDefault = <Info />;

export function BulleAide({ title, description, className, icon = iconDefault, hideIcon, children }: BulleAideProps) {
    // Utilise le contexte du formulaire s'il est disponible, sinon valeurs par défaut
    let config;
    try {
        const globalForm = useGlobalForm();
        config = globalForm?.config;
    } catch {
        // Contexte non disponible, on utilise les valeurs par défaut
        config = null;
    }

    // Utilise la configuration par défaut si hideIcon n'est pas explicitement défini
    const shouldHideIcon = hideIcon ?? config?.components?.bulleAide?.hideIcon ?? false;

    return (
        <div className={cn('bg-card flex flex-col items-center text-left sm:flex-row gap-1 sm:gap-3 px-2 sm:px-6 py-4 rounded-xl w-full', className)}>
            {!shouldHideIcon && icon && <div className="flex shrink-0">{icon}</div>}

            <div className="space-y-1.5 flex-1">
                {title && <h3 className="text-base font-medium">{title}</h3>}

                {Array.isArray(description) ? (
                    description.map((d, i) => (
                        <div
                            className="text-[13px] leading-normal"
                            key={i}
                        >
                            {d}
                        </div>
                    ))
                ) : typeof description === 'string' ? (
                    <p className="text-[13px] leading-normal">{description}</p>
                ) : null}

                {children && <div className="text-[13px] leading-normal space-y-1.5">{children}</div>}
            </div>
        </div>
    );
}
